var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 26.4453H0.421875V21.2891H4.64062L6.04688 14.375H0.421875V9.19531H7.10156L8.95312 0.0546875H14.2031L12.3516 9.19531H17.5312L19.3359 0.0546875H24.7734L22.8984 9.19531H26.1328V14.375H21.8438L20.4375 21.2891H26.1328V26.4453H19.3828L17.5312 35.5859H12.3047L14.1094 26.4453H8.90625L7.05469 35.5859H1.75781L3.60938 26.4453ZM11.3203 14.375L9.9375 21.2891H15.1406L16.5 14.375H11.3203Z",
    fill: "url(#paint0_linear_1252_6193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1252_6193",
    x1: 0,
    y1: 2,
    x2: 18.4322,
    y2: 39.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPoint);
export default __webpack_public_path__ + "static/media/BulletPoint.1f66aff41f4786fbcb90c5c525f056cd.svg";
export { ForwardRef as ReactComponent };